import { Checkbox, Layout, Menu, Image, Row, Col, Button, Modal, Upload, Card, Input, DatePicker, Typography, Timeline, Avatar } from 'antd';
import React, { useEffect, useState, useRef } from 'react';
import { Navigate, Outlet, useNavigate, useLocation } from 'react-router-dom'
import { EditOutlined, PlusOutlined, UserOutlined } from '@ant-design/icons';
// import { Line, Pie, measureTextWidth } from '@ant-design/plots';
import dayjs from 'dayjs';
import axios from 'axios';
import OverviewCalendar from '../schedule_timeline/OverviewCalendar';
const { Title, Paragraph, Text, Link } = Typography;
const { Dragger } = Upload;
const { TextArea } = Input;
const CheckboxGroup = Checkbox.Group;
const AdminHome = () => {
    const [color, setColor] = useState(['#4A837D', '#9E8562', '#547186']);
    const [teacherCheckedList, setTeacherCheckedList] = useState([]);
    const [classCheckedList, setClassCheckedList] = useState([]);
    const [teacher_list, set_teahcer_list] = useState([]);
    const [class_list, set_class_list] = useState([]);
    useEffect(() => {
        get_teacher();
        get_class();
    }, [])
    const get_teacher = () => {
        axios
            .get('/cramSchool/api/teacher', { params: { is_resign: true } })
            .then((response) => {
                let data_tmp = response.data.data.filter(item => item.name != null);
                set_teahcer_list(data_tmp.map(map_item => {
                    return {
                        value: map_item.teacher_id,
                        label: map_item.name,
                    };
                }))
            })
    }
    const get_class = () => {
        axios
            .get('/cramSchool/api/class')
            .then((response) => {
                let data_tmp = response.data.data.filter(item => item.name != null);
                set_class_list(data_tmp.map(map_item => {
                    return {
                        value: map_item.class_id,
                        label: map_item.name,
                    };
                }))
            })
    }
    return (
        <>
            <Row gutter={[16, 16]}>
                <Col span={24}>
                    <Checkbox indeterminate={classCheckedList.length > 0 && classCheckedList.length < teacher_list.length} onChange={(e) => setClassCheckedList(e.target.checked ? class_list.map((item) => item.value) : [])} checked={class_list.length === classCheckedList.length}>
                        全選
                    </Checkbox>
                    <CheckboxGroup options={class_list} value={classCheckedList} onChange={list => setClassCheckedList(list)} />
                </Col>
                <Col span={24}>
                    <Checkbox indeterminate={teacherCheckedList.length > 0 && teacherCheckedList.length < teacher_list.length} onChange={(e) => setTeacherCheckedList(e.target.checked ? teacher_list.map((item) => item.value) : [])} checked={teacher_list.length === teacherCheckedList.length}>
                        全選
                    </Checkbox>
                    <CheckboxGroup options={teacher_list} value={teacherCheckedList} onChange={list => setTeacherCheckedList(list)} />
                </Col>
                <Col span={24}>
                    <OverviewCalendar
                        props_items={[
                            {
                                id: 2, //製令單號-›製程序號
                                group: 1, //machine_id
                                title: '製程1',//製令單號-製程序號
                                is_order: false,
                                order_time_start: dayjs("2023-09-04 23:00"),
                                order_time_end: dayjs("2023-09-15 23:00").add(1, 'day'),
                                start_time: dayjs("2023-09-05 23:00"),
                                end_time: dayjs("2023-09-07 23:00").add(1, 'day'),
                                average_start_time: dayjs("2023-09-05 23:00"),
                                average_end_time: dayjs("2023-09-07 23:00").add(1, 'day'),
                                height: 19.5,
                                clicking: false,
                                machine: [
                                    {
                                        "machine": "CNC機台1",
                                        "crew": ["Louise", "Arthur", "Catherine"],
                                        "loading": 30,
                                        "process": [
                                            {
                                                "process_name": "今日剩餘時間(小時)",
                                                "percent": 16.5,
                                                "machine": "CNC機台1",
                                            },
                                            {
                                                "process_name": "製程2",
                                                "percent": 4.5,
                                                "machine": "CNC機台1",
                                            },
                                            {
                                                "process_name": "製程3",
                                                "percent": 3,
                                                "machine": "CNC機台1",
                                            }
                                        ]
                                    },
                                ],
                            }
                        ]}
                        can_create_event={false} />
                </Col>
            </Row >

        </>
    )
}
export default AdminHome;
